import { ColumnDef } from 'features/common/hooks/useColumnSelection';

export const COLUMN_DEFS: ColumnDef[] = [
	{ key: 'email', labelKey: 'compedTickets-col-email', minWidth: 200, priority: 1 },
	{ key: 'firstName', labelKey: 'compedTickets-col-firstName', minWidth: 160, priority: 2 },
	{ key: 'lastName', labelKey: 'compedTickets-col-lastName', minWidth: 160, priority: 3 },
	{ key: 'ticketType', labelKey: 'compedTickets-col-ticketType', minWidth: 180, priority: 4 },
	{ key: 'status', labelKey: 'compedTickets-col-status', minWidth: 120, priority: 5 },
	// Quantity is hidden by default: the per-type breakdown in the ticketType column already shows
	// the count per type (N× lines), so the standalone total is redundant on first load. Users can
	// re-enable it via the Columns picker (mirrors the Transactions table's quantity column).
	{ key: 'quantity', labelKey: 'compedTickets-col-quantity', minWidth: 100, priority: 6, defaultHidden: true },
];
